module.exports = __webpack_public_path__ + "static/media/ANAHUAC_independeciatortilla.6fdff4ce.png";